import script from "./Image.vue?vue&type=script&setup=true&lang=ts"
export * from "./Image.vue?vue&type=script&setup=true&lang=ts"

import "./Image.vue?vue&type=style&index=0&id=436e9a39&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-436e9a39"]])

export default __exports__